module.exports = __webpack_public_path__ + "static/media/middle.5320e6f4.jpg";